import { useTranslation } from "react-i18next"
import Avatar from "components/commons/Avatar"
import PageLayout from "components/layout/PageLayout"
import { useGetMyCompanyInfoQuery } from "./api/companyApiSlice"
import CompanyActivityStats from "./components/CompanyActivityStats"
import CompanyNav from "./components/CompanyNav"
import CompanyFileStats from "./components/CompanyFileStats"
import EntityFingerprint from "components/commons/EntityFingerprint"

const CompanyDetail = () => {

    const [t, i18n] = useTranslation("global")

    const apiUrl = process.env.REACT_APP_API_URL

    const {
        data: companyInfo,
        isFetching,
        isSuccess,
        isLoading,
        isError,
        error,
        refetch,
    } = useGetMyCompanyInfoQuery()

    let content

    if (isSuccess) {

        const uniqueRoles = [...new Set(companyInfo.stakeholders.map(s => s.role.name))]

        content =
            <>
                <CompanyNav />

                <div className="card bg-black bg-opacity-10 text-white mb-4">
                    <div className="card-header">
                        <i className="fa-solid fa-circle-info"></i>  {t("property.infos")}

                    </div>
                    <div className="card-body">
                        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3">

                            <div className="col">
                                <p className="text-accent">{t("property.administrators")}:</p>
                                {
                                    companyInfo.stakeholders.filter(u => u.role.isCritical).map(admin =>
                                        <Avatar displayName={admin.user.displayName} guid={admin.user.guid} key={admin.user.guid} />
                                    )
                                }
                            </div>

                            <div className="col">
                                <p className="text-accent">{t("property.vat")}:<br /> <span className="breadcrumb-item active">{companyInfo.company.vat}</span></p>
                            </div>

                            <div className="col">
                                {
                                    companyInfo.company.img ?
                                    <img width="200" src={`${apiUrl}/file?file=${companyInfo.company.img}`} />
                                    : <span className="d-flex align-items-center gap-1"><i className="fa-solid fa-image h4"></i> {t("helper.no_logo_set")}</span>
                                }

                            </div>

                        </div>
                    </div>
                    <div className="card-footer">
                        <EntityFingerprint guid={companyInfo.company.guid}/>
                    </div>
                </div>

                <div className="card bg-black bg-opacity-10 text-white mb-4 text-center">
                    <div className="card-body">
                        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3">
                            <div className="col p-2">
                                {t("entity.users")}<br />
                                <h2 className="p-2"><i className="fas fa-users"></i> {companyInfo.stakeholders.length}</h2>
                            </div>
                            <div className="col p-2">
                                {t("entity.roles")}<br />
                                <h2 className="p-2"><i className="fa-solid fa-user-shield" /> {uniqueRoles.length}</h2>
                            </div>
                            <div className="col p-2">
                                {t("entity.businessUnits")}<br />
                                <h2 className="p-2"><i className="fa-solid fa-building-flag"></i> {companyInfo.businessUnits.length}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <CompanyActivityStats />
                <CompanyFileStats/>
            </>
    }


    return <PageLayout
        pageTitle={isFetching ? t("helper.loading") : companyInfo.company.name}
        onPageRefresh={refetch}
        isLoadingContent={isFetching}
        isLoadingPage={isLoading}
        bodyContent={content}
    />

}


export default CompanyDetail